var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-wrapper"},[_c('HeaderBar'),_c('main',{staticClass:"main-page",class:{ 'report-page-bg': _vm.isReportPage }},[_c('keep-alive',{key:_vm.key,attrs:{"include":_vm.keepAlivePageName}},[_c('router-view',{key:_vm.key})],1)],1),_c('FooterBar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }